import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../environments/environment";
import { HelperService } from "./helper.service";
import { StorageKeys, StorageService } from "./storage.service";
import { UserService } from "./user.service";
import { catchError, map } from "rxjs/operators";
import { Observable, of as observableOf, of, Subject, throwError } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class RmaService {
  public returnAuthurizationItems$: Subject<any> = new Subject();
  _returnAuthorizationItems: any;
  constructor(private http: HttpClient, private _helpers: HelperService, private userService: UserService, private storage: StorageService) {
    this._helpers.userID = this.userService.user ? this.userService.user.id : undefined;
  }

  get returnAuthorizationItems() {
    if (!this._returnAuthorizationItems) {
      this._returnAuthorizationItems = this.storage.getItem(StorageKeys.RETURN_AUTHORIZATION);
    }
    return this._returnAuthorizationItems;
  }
  set returnAuthorizationItems(items) {
    this._returnAuthorizationItems = items;
    this.storage.setTimestamp("rma", 24);
    this.storage.setItem(StorageKeys.RETURN_AUTHORIZATION, items);
  }

  getRmas(fresh?, autoSubscribe = true) {
    const returnAuthItems = this.returnAuthorizationItems;
    if (returnAuthItems && !fresh) {
      this.returnAuthurizationItems$.next(returnAuthItems);
    }
    if (returnAuthItems && !fresh && this.storage.isDataFresh("rma")) {
      return observableOf(returnAuthItems);
    } else {
      let fn = this.http.get(environment.apiUrl + "orders/rma_data", this._helpers.getHttpOptions()).pipe(
        map((response: any) => {
          this.returnAuthorizationItems = response;
          this.returnAuthurizationItems$.next(response);
        })
      );
      if (autoSubscribe) {
        fn.subscribe();
      } else {
        return fn;
      }
    }
  }
}
